<div class="row col-md-12 pr-0">
    <h6><b>Select Mailing Method and Address</b></h6>
</div>
<form (ngSubmit)="postMailingAddress()" #mailingAddressForm="ngForm">
    <div class="row">

        <div class="row px-3">
            <div class="col-md-12">
                <label class="create-task-label required">Select Processing Type</label>
                <div class="p-formgroup-inline">
                    <!-- Regular Processing Radio Button -->
                    <div class="p-field-checkbox">
                        <p-radioButton name="processingType" value="regular" (onClick)="onChangeProcessingType()"
                            [(ngModel)]="processingType" inputId="regular"></p-radioButton>
                        <label for="regular" class="create-task-label">Regular</label>
                    </div>
        
                    <!-- Premium Processing Radio Button -->
                    <div class="p-field-checkbox">
                        <p-radioButton name="processingType" value="premium" (onClick)="onChangeProcessingType()"
                            [(ngModel)]="processingType" inputId="premium"></p-radioButton>
                        <label for="premium" class="create-task-label">Premium</label>
                    </div>
                </div>
            </div>
            <div class="col-md-12 mb-3">
                <label class="create-task-label d-block required">Select {{visaType === 'H1-B' ? 'Lockbox' : 'Service Center'}}</label>
                <p-dropdown [options]="serviceCenters" name="serviceCenterId" [(ngModel)]="serviceCenterId" optionLabel="name"
                    (onChange)="changeCenter($event)" optionValue="id" placeholder="Select" [style]="{'minWidth':'100%'}">
                </p-dropdown>
            </div>
        </div>

        <div class="col-md-12 pr-0">
            <p-table [value]="mailingAddress" (onRowSelect)="onRowSelect($event)"  [(selection)]="selectedServiceCenter" class="uscis-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 3rem"></th>
                        <th>Mailing Method</th>
                        <th>Attn To</th>
                        <th colspan="2">Service Center Address</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>
                            <p-tableRadioButton [disabled]="disabledControls" [value]="item"></p-tableRadioButton>
                        </td>
                        <td>{{item.serviceCenters.shippingServiceType.code}}</td>
                        <td>{{item.serviceCenters.attentionTo}}</td>
                        <td colspan="2">{{item.serviceCenterName}} -
                            {{ formatAddress( item.serviceCenters.addressLine1, item.serviceCenters.addressLine2,
                                item.serviceCenters.countryCode.countryName, item.serviceCenters.postCode )
                            }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
    <p-divider></p-divider>
    <div class="row">
        <div class="col-md-12 save-btn">
            <button pButton type="submit" label="Save" icon="pi pi-save"
                [ngClass]="mailingAddressForm.invalid  || disabledControls ? 'btn-success button-width-icon-left mr-3 pl-4 pr-4 btn-success_disabled save-btn':'btn-success button-width-icon-left mr-3  pl-4 pr-4 save-btn'"
                [disabled]="mailingAddressForm.invalid  || disabledControls"></button>
        </div>
    </div>
</form>